import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all products with filters - UPDATE THIS FUNCTION
export const getProducts = async (params = {}) => {
  try {
    const response = await api.get(`${API_URL}/product`, {
      params: params, // Add this line to send query parameters
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this to properly handle errors
  }
};

// Add a new product
export const addProduct = async (product) => {
  try {
    const response = await api.post(`${API_URL}/product`, product, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};

// Update a product
export const updateProduct = async (id, product) => {
  try {
    const response = await api.put(`${API_URL}/product/${id}`, product, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};

// Update product status
export const updateProductStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(
      `${API_URL}/product/status/${id}`,
      updateStatusObj,
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};

// Delete one or more already-saved product images
// DELETE admin/product/:id/image  --> body: { imagePaths: ["/product_images/abc.jpg", ...] }
export const deleteProductImages = async (id, imagePaths) => {
  try {
    const response = await api.delete(`${API_URL}/product/${id}/image`, {
      data: { imagePaths },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Reorder already-saved product images
// PUT admin/product/:id/images/reorder --> body: { images: ["/product_images/third.jpg", ...] }
export const reorderProductImages = async (id, images) => {
  try {
    const response = await api.put(`${API_URL}/product/${id}/images/reorder`, {
      images,
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Fetch product reviews (GET api/admin/product/reviews/:productId)
export const getProductReviews = async ({ id, page = 1, limit = 10 }) => {
  try {
    const response = await api.get(
      `${API_URL}/product/reviews/${id}?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Update product review approval (PUT api/admin/product/reviews/approval/:reviewId)
// req.body --> approved: true | false
export const updateProductReviewStatus = async (reviewId, approved) => {
  try {
    const response = await api.put(
      `${API_URL}/product/reviews/approval/${reviewId}`,
      { approved },
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Delete a product
export const deleteProduct = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/product/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Add this
  }
};
